<template>
  <b-navbar-nav>
    <b-nav-item
      v-track-click
      id="nav-dashboard"
      :disabled="$attrs.isDisabled"
      :to="{ name: 'dashboard' }"
      exact
      :active="isNavActive('dashboard')"
    >
      <b-icon-grid-fill class="menu-icon mr-2" /> {{ $t('menu.dashboard') }}
    </b-nav-item>
    <b-nav-item
      v-track-click
      id="nav-invoices"
      :disabled="$attrs.isDisabled"
      :to="{ name: 'invoices' }"
      :active="isNavActive('invoices')"
    >
      <b-icon-files class="menu-icon mr-2" /> {{ $t('menu.invoices') }}
    </b-nav-item>
    <b-nav-item-dropdown
      id="nav-payments"
      :class="[
        'account-dropdown mt-md-3 pl-3 pl-lg-0',
        isDropdownActive(['transactions', 'accountSummary', 'remittances'])
      ]"
    >
      <template #button-content>
        <b-icon-graph-up class="menu-icon" /> {{ $t('menu.payments') }}
      </template>
      <b-dropdown-item
        v-track-link
        id="nav-transactions"
        class="primary-dropdown"
        :disabled="$attrs.isDisabled"
        :to="{ name: 'transactions' }"
        :active="isNavActive('transactions')"
      >
        <div class="d-flex align-items-center">
          <svg
            width="18"
            height="12"
            viewBox="0 0 18 12"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-3"
          >
            <path
              d="M6.50832 7.66675H0.666656V9.33341H6.50832V11.8334L9.83332 8.50008L6.50832 5.16675V7.66675ZM11.4917 6.83341V4.33341H17.3333V2.66675H11.4917V0.166748L8.16666 3.50008L11.4917 6.83341Z"
              fill="inherit"
            />
          </svg>
          {{ $t('menu.activity') }}
        </div>
      </b-dropdown-item>
      <b-dropdown-item
        v-track-link
        id="nav-accountSummary"
        class="primary-dropdown"
        :disabled="$attrs.isDisabled"
        :to="{ name: 'accountSummary' }"
        :active="isNavActive('accountSummary')"
      >
        <div class="d-flex align-items-start">
          <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-3"
          >
            <path
              d="M4.41666 8.33325H2.74999V14.1666H4.41666V8.33325ZM9.41666 8.33325H7.74999V14.1666H9.41666V8.33325ZM16.5 15.8333H0.666656V17.4999H16.5V15.8333ZM14.4167 8.33325H12.75V14.1666H14.4167V8.33325ZM8.58332 2.71659L12.925 4.99992H4.24166L8.58332 2.71659ZM8.58332 0.833252L0.666656 4.99992V6.66658H16.5V4.99992L8.58332 0.833252Z"
              fill="inherit"
            />
          </svg>
          {{ $t('menu.accountSummary') }}
        </div>
      </b-dropdown-item>
      <b-dropdown-item
        v-track-link
        id="nav-remittances"
        class="primary-dropdown"
        :to="{ name: 'remittances' }"
        :active="isNavActive('remittances')"
      >
        <div class="d-flex align-items-center">
          <svg
            width="18"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-3"
          >
            <g clip-path="url(#clip0_6455_10492)">
              <path
                d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 20V4H13V9H18V20H6Z"
                fill="inherit"
              />
            </g>
            <defs>
              <clipPath id="clip0_6455_10492">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>

          {{ $t('menu.remittance') }}
        </div>
      </b-dropdown-item>
    </b-nav-item-dropdown>
    <b-nav-item
      v-track-click
      id="nav-buyers"
      :disabled="$attrs.isDisabled"
      :to="{ name: 'buyers' }"
      :active="isNavActive('buyers')"
    >
      <div class="d-flex flex-column align-items-center position-relative">
        <div class="d-flex align-items-center">
          <b-icon-cart-3 class="menu-icon mr-2" /> {{ $t('menu.buyers') }}
        </div>
        <div class="badge-buyer">
          <b-badge variant="success">{{ $t('menu.checkLimitsHere') }}</b-badge>
        </div>
      </div>
    </b-nav-item>
    <!-- Commenting for now as TV data is not updated.
      <b-nav-item
      v-track-click
      id="nav-drip-one"
      :disabled="$attrs.isDisabled"
      :to="{ name: 'insights' }"
      target="_blank"
      v-show="$attrs.enableInsights">
      <div class="d-flex flex-column align-items-center position-relative">
        <div class="d-flex align-items-center">
          <chart-bar-icon class="menu-icon" /> {{ $t('menu.dripOne') }}
          <b-icon-box-arrow-up-right class="open-in-new" />
        </div>
      </div>
    </b-nav-item> -->
    <b-nav-item-dropdown
      id="nav-resources"
      :class="[
        'account-dropdown mt-md-3 pl-3 pl-lg-0',
        isDropdownActive([
          'chargesCalculator',
          'bankHolidays',
          'masterBlList',
          'cmaList'
        ])
      ]"
    >
      <template slot="button-content">
        <b-icon-layers-fill class="menu-icon" /> {{ $t('menu.resources') }}
        <div class="badge-buyer is-nav-drop">
          <b-badge variant="success">{{ $t('menu.new') }}</b-badge>
        </div>
      </template>
      <b-dropdown-item
        v-track-link
        id="charges-calculator"
        class="primary-dropdown"
        :to="{ name: 'chargesCalculator' }"
        :active="isNavActive('chargesCalculator')"
      >
        <div class="d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.589"
            height="12.589"
            viewBox="0 0 12.589 12.589"
            class="mr-3"
          >
            <path
              class="a"
              fill="inherit"
              d="M8.294,2a6.294,6.294,0,1,0,6.294,6.294A6.3,6.3,0,0,0,8.294,2Zm.888,10.128v1.2H7.5V12.115a2.342,2.342,0,0,1-2.058-2.14H6.677c.063.661.516,1.177,1.668,1.177,1.234,0,1.511-.617,1.511-1,0-.522-.277-1.013-1.681-1.347-1.561-.378-2.631-1.02-2.631-2.31A2.182,2.182,0,0,1,7.5,4.474V3.259H9.182V4.486A2.225,2.225,0,0,1,10.976,6.62H9.742c-.031-.7-.4-1.177-1.4-1.177-.944,0-1.511.428-1.511,1.032,0,.529.409.875,1.681,1.2s2.631.875,2.631,2.461c-.006,1.152-.869,1.781-1.964,1.989Z"
              transform="translate(-2 -2)"
            />
          </svg>
          {{ $t('menu.chargesCalculator') }}
        </div>
      </b-dropdown-item>
      <b-dropdown-item
        v-track-link
        id="nav-holidays"
        class="primary-dropdown"
        :disabled="$attrs.isDisabled"
        :to="{ name: 'bankHolidays' }"
        :active="isNavActive('bankHolidays')"
      >
        <div class="d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11.92"
            height="13.244"
            viewBox="0 0 11.92 13.244"
            class="mr-3"
          >
            <path
              class="a"
              d="M6.973,7.96H5.649V9.284H6.973Zm2.649,0H8.3V9.284H9.622Zm2.649,0H10.946V9.284h1.324ZM13.6,3.324h-.662V2H11.609V3.324h-5.3V2H4.987V3.324H4.324A1.318,1.318,0,0,0,3.007,4.649L3,13.92a1.324,1.324,0,0,0,1.324,1.324H13.6A1.328,1.328,0,0,0,14.92,13.92V4.649A1.328,1.328,0,0,0,13.6,3.324Zm0,10.6H4.324V6.635H13.6Z"
              transform="translate(-3 -2)"
              fill="inherit"
            />
          </svg>
          {{ $t('menu.holiday') }}
        </div>
      </b-dropdown-item>
      <b-dropdown-item
        v-track-link
        id="master-bl-list"
        class="primary-dropdown"
        :to="{ name: 'masterBlList' }"
        :active="isNavActive('masterBlList')"
      >
        <div class="d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12.745"
            height="14.017"
            viewBox="0 0 12.745 14.017"
            class="mr-3"
          >
            <path
              class="a"
              d="M13.468,13.743a4.481,4.481,0,0,1-2.549-.841,4.383,4.383,0,0,1-5.1,0,4.481,4.481,0,0,1-2.549.841H2v1.274H3.273a5.625,5.625,0,0,0,2.549-.631,5.577,5.577,0,0,0,5.1,0,5.544,5.544,0,0,0,2.549.631h1.274V13.743ZM3.242,12.469h.032a3.474,3.474,0,0,0,2.549-1.274,3.474,3.474,0,0,0,2.549,1.274,3.474,3.474,0,0,0,2.549-1.274,3.474,3.474,0,0,0,2.549,1.274H13.5l1.2-4.256a.671.671,0,0,0-.038-.5.635.635,0,0,0-.382-.319l-.816-.268V4.186a1.278,1.278,0,0,0-1.274-1.274H10.282V1H6.459V2.911H4.548A1.278,1.278,0,0,0,3.273,4.186V7.129L2.452,7.4a.635.635,0,0,0-.382.319.641.641,0,0,0-.038.5ZM4.548,4.186h7.646V6.715L8.371,5.46,4.548,6.715Z"
              transform="translate(-1.998 -1)"
              fill="inherit"
            />
          </svg>
          {{ $t('menu.masterBL') }}
        </div>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="!['es-MX'].includes($i18n.locale)"
        v-track-link
        id="cma-list"
        class="primary-dropdown"
        :to="{ name: 'cmaList' }"
        :active="isNavActive('cmaList')"
      >
        <div class="d-flex align-items-center">
          <b-icon-list-ul class="nav-drop-image" /> {{ $t('menu.cmaList') }}
        </div>
      </b-dropdown-item>
    </b-nav-item-dropdown>
    <b-nav-item
      v-if="$attrs.isIndian"
      v-track-click
      id="freshdesk-support-mobile"
      target="_blank"
      href="https://dripassist.freshdesk.com/customer/login"
    >
      <div class="d-flex align-items-center">
        <b-icon-question-square-fill class="menu-icon mr-2" />
        {{ $t('menu.support') }}
        <b-icon-box-arrow-up-right class="menu-icon open-in-new" />
      </div>
    </b-nav-item>
  </b-navbar-nav>
</template>
<script>
export default {
  computed: {
    activeLink() {
      return this.$route.name
    }
  },
  methods: {
    isDropdownActive(pages) {
      if (pages.includes(this.activeLink)) {
        return 'active-dropdown'
      }
      return ''
    },
    isNavActive(value) {
      return this.$route.name === value
    }
  }
}
</script>
<style lang="scss">
.dropdown-item {
  div > svg {
    fill: $wealthy-green-400;
  }
  &.active > div > svg {
    fill: $white;
  }
}
.dropdown-item:hover:not(.active),
.dropdown-item:focus:not(.active) {
  background: $sky-blue-50;
  color: $wealthy-green-400;
}
</style>
<style lang="scss" scoped>
@import '../assets/scss/variables';

.main-navbar {
  .navbar-brand {
    padding: 0.9rem;
    border-right: 1px solid $dc-form-border-color;
    box-shadow: 0 2px 5px 0 rgba(black, 0.05);
  }
  ul {
    font-family: $montserrat;
    li {
      & > a {
        display: flex;
        align-items: center;
        padding: 1.5rem 1rem !important;
        font-size: 1rem;
        &.active {
          border-bottom: 2px solid $secondary;
          font-weight: bold;
        }
        @include media-breakpoint-down(sm) {
          padding: 1rem !important;
          &.active {
            border-bottom: none;
          }
        }
        span {
          bottom: 0.125em;
          margin-right: 0.25rem;
        }
      }
      &.active-dropdown {
        border-bottom: 2px solid $secondary;
        font-weight: bold;
        @include media-breakpoint-down(sm) {
          border-bottom: none;
        }
      }
      a {
        &.primary-dropdown {
          padding: 0.5rem 1.5rem !important;
          .nav-drop-image {
            height: 1rem;
            margin-right: 1rem;
            color: $dc-label-color;
          }
        }
      }
    }
  }
}
.badge-buyer {
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  span {
    margin-right: 0 !important;
  }
  &.is-nav-drop {
    top: auto;
    bottom: 0;
  }
}
.menu-icon {
  margin-right: 0.25rem;
  width: 0.8rem;
}
.open-in-new {
  margin-left: 0.5rem;
}
.nav-drop-image {
  height: 1rem;
  margin-right: 1rem;
  color: $dc-label-color;
}
.nav-drop-svg {
  height: 1rem;
  color: $dc-label-color;
  margin-right: 1rem !important;
  display: inline-block;
}

@include media-breakpoint-down(md) {
  .badge-buyer {
    padding-left: 3rem;
    &.is-nav-drop {
      width: 100%;
      bottom: -1rem;
    }
  }
}
.search-icon {
  width: 1.25rem;
}
</style>
